import { takeLatest, all, fork, call, put } from 'redux-saga/effects';
import Actions from 'actions';
import api from 'api';

function* validatePromoCode({ data, callbacks }) {
  try {
    const response = yield call(api.validatePromoCode, data);
    yield put(Actions.validatePromoCodeSuccess(response.data));
    if (typeof callbacks?.success === 'function') {
      yield call(callbacks.success, response.data);
    }
  } catch (error) {
    yield put(Actions.validatePromoCodeFail(error));
    if (typeof callbacks?.failure === 'function') {
      yield call(callbacks.failure, error);
    }
  }
}

function* watchvalidatePromoCode() {
  yield takeLatest(Actions.VALIDATE_PROMO_CODE_REQUEST, validatePromoCode);
}

export default function* create() {
  yield all([fork(watchvalidatePromoCode)]);
}
